import React, { useState } from 'react';
import { orderBy } from 'lodash';
import { useTranslation } from 'react-i18next';
import s from './Block.module.scss';

const Block = ({ children, title, backgroundImage, items, game }) => {
  const { t } = useTranslation();
  const [showAll, setShowAll] = useState(false);

  return (
    <div
      className={s.container}
      style={{
        background: `url(${backgroundImage}) no-repeat left bottom #ffffff`,
        backgroundSize: '70%'
      }}
    >
      <h2>{title}</h2>
      <div className={s.content}>{children}</div>
      {showAll ?
        <h3>{t('top_100')}</h3> :
        <h3>{t('top_5')}</h3>
      }
      <div className={s.table}>
        {game === 1 ?
          items && game &&
            orderBy(items, ['place'], ['asc'])
              .slice(0, showAll ? 100 : 5)
              .map((c, index) => (
                <div className={s.item} key={index}>
                  <span>{c.maskedEmail}</span>
                    <span>{c.time.slice(6, 12)} {t('s')}</span>
                </div>
              )) :
          items && game &&
            <div className={s.item_2_3}>
              <div>
                {orderBy(items, ['place'], ['asc'])
                  .slice(0, showAll ? 100 : 5)
                  .map((c, index) => (
                    <div key={index}>
                      <span>{c.maskedEmail}</span>
                      <span>{c.score}</span>
                    </div>
                  ))}
              </div>
              <div>
                {orderBy(items, ['place'], ['asc'])
                .slice(0, showAll ? 100 : 5)
                .map((c, index) => (
                  <div className={s.time} key={index}>({c.time.slice(0, 12)})</div>
                ))}
              </div>
            </div>
        }
      </div>
      {!showAll && items.length > 5 && (
        <button
          className={s.showMore}
          onClick={() => setShowAll(true)}
          type="submit"
        >
          {t('show_more', { itemsLength: items.length - 5 })}
        </button>
      )}
      {showAll ?
        <button
          className={s.showMore}
          onClick={() => setShowAll(false)}
          type="submit"
        >
          {t('show_top_5')}
        </button> :
        null
      }
    </div>
  );
};

export default Block;
